import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=01c86d72&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/propersam/Desktop/gh-pages/propersam.github.io/my_portfolio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib'
installComponents(component, {VFooter})
